import { useUBL } from '@common/log-manager';
import { ShopUxUbl } from '@domains/storehome-common';

interface Params {
  shop_id: string;
}

export const useBestProductCarouselUBL = ({ shop_id }: Params) => {
  const tracker = useUBL();
  const clickMoreButtonUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      category: 'click',
      navigation: 'shop_detail',
      navigation_sub: { shop_id },
      object_section: 'best',
      object_type: 'button',
      object_id: 'see_more',
      data: ubl?.server_log ?? null,
    });
  };

  const clickCarouselMoreButtonUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      category: 'click',
      navigation: 'shop_detail',
      navigation_sub: { shop_id },
      object_section: 'best',
      object_type: 'button',
      object_id: 'carousel_more',
      data: ubl?.server_log ?? null,
    });
  };

  const clickTabUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      category: 'click',
      navigation: 'shop_detail',
      navigation_sub: { shop_id },
      object_section: 'best_filter',
      object_type: 'button',
      object_id: ubl?.object?.id ?? '',
      data: ubl?.server_log ?? null,
    });
  };

  return {
    clickMoreButtonUBL,
    clickCarouselMoreButtonUBL,
    clickTabUBL,
  };
};
